import { defineComponent as _defineComponent } from 'vue'
import {Configuration} from "@/app/helpers/QueryParams";
import RadioOrCheckBox from "@/components/RadioOrCheckBox.vue";
import debounce from "lodash/debounce";
import Client from "@/app/http/Client";
import {Ref, ref} from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'CarTradeInConfiguration',
  props: {
    config: null,
    title: null
  },
  setup(__props: any) {

const props = __props as {
  config: Configuration;
  title: string;
};



const tradeInCar: Ref<{ brand: string, model: string } | null> = ref(null)

const getTradeInCar = debounce(function () {
  if (props.config.tradeInCarLicense === null || props.config.tradeInCarLicense.length<6 ) {
    tradeInCar.value =null
    return
  }

  return Client.get("/cars/license-plate/" + props.config.tradeInCarLicense)
      .then((response: any) => {
        tradeInCar.value = {brand: response.data.merk, model: response.data.handelsbenaming}
      })
      .catch(function () {
        tradeInCar.value = null
      })
}, 250)

return { __sfc: true,props, tradeInCar, getTradeInCar, RadioOrCheckBox }
}

})